import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchService } from '@services/search.service';
import { GlobalService } from '@common/global';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
declare var require: any
const FileSaver = require('file-saver');
import { DatePipe } from '@angular/common';
import { ModalDirective } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-mailhome',
  templateUrl: './mailhome.component.html',
  styleUrls: ['./mailhome.component.sass']
})
export class MailhomeComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    clickable: true,
    dictDefaultMessage: "<i class='fa fa-paperclip'></i>"
  };
  show: any = { mail: true, compose: false, view: false, draft: false };
  attachment_paths: any = [];
  response: any = [];
  upload = false;
  upload_btn = false;
  view_response: any = [];
  totalRecord = 0;
  pathToMedia: any = [];
  pageCounter = 1;
  pageno = 1;
  mail_attachments: any = [];
  to: any = [];
  cc: any = [];
  bcc: any = [];
  params: any = [];
  items: any = [];
  application = "mail";
  component = 'm';
  compose_response: any = [];
  terms: any = [];
  fterms: any = [];
  total_record = 0;
  res: any = [];
  rows = 1;
  checkbox_all = 0;
  members_response: any = [];
  dataLoding = true;
  mailComposeForm: FormGroup;
  mailListForm: FormGroup;
  mlabel = "";
  btn_process = false;
  view_page = true;
  mailForm: FormGroup;
  error: any = { subject: '', body: '', bcc: '', cc: '', to: '' };
  dterms = [{ "term": "inbox", "count": "0" }, { "term": "sent", "count": "0" }, { "term": "trash", "count": "0" }];
  constructor(private datePipe: DatePipe, private fb: FormBuilder, private _mail: MailService, private _searchService: SearchService, private _global: GlobalService) {
    this.rows = this._global.ROWS;
    this.loadMail();
    this.mailForm = this.fb.group({
      label: []
    });
    this.mailComposeForm = this.fb.group({
      to: [],
      cc: [],
      bcc: [],
      subject: [],
      body: []
    });
    this.mailListForm = this.fb.group({
      list: new FormArray([])
    });

  }
  @ViewChild('mailLabelModal', { static: false }) mailLabelModal: ModalDirective;
  ngOnInit() {
  }
  loadMail() {
    this.checkbox_all = 0;
    this.dataLoding = true;
    this.mailListForm = this.fb.group({
      list: new FormArray([])
    });
    this.visible('mail');
    this.items = [];
    let p = {
      component: this.component,
      application: this.application,
      start: 0,
      rows: this.rows,
      facetQuery: true
    };
    this._mail.search(p).subscribe(
      data => {
        this.dataLoding = false;
        this.response = data["response"]["docs"];
        this.res = data["response"];
        this.terms = this._global.getVal(this.res, 'facets.label.terms', {});
        Object.entries(this.dterms).forEach(([key, value]) => {
          if (this._global.getVal(this.res, 'facets.label.terms.' + value['term'], '')) {
            let termF = false;
            Object.entries(this.terms).forEach(([key, v1]) => {
              if (v1['term'] == value['term']) {
                termF = true;
              }
            });

            if (termF == false) {
              let zzz = { "term": value['term'], "count": "0" };
              this.res.facets.label.terms.push(zzz);
            }
          }

        });
        this.fterms = this._global.getVal(this.res, 'facets.label.terms', {});

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

    let pa = {
      'component': this.component,
      'application': this.application,
      "start": 0,
      "rows": this.rows,
      label: 'inbox',
    };
    this.mlabel = pa.label;
    this._mail.search(pa).subscribe(
      data => {
        this.dataLoding = false;
        this.total_record = this._global.getVal(data, 'response.numFound', 0);
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.params = this._global.getVal(data, 'request', '');
          this.items = this._global.getVal(data, 'response.docs', '');
          Object.entries(this.items).forEach(([key, value]) => {
            const control = this.fb.control('');
            (this.mailListForm.controls.list as FormArray).push(control);
          });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  getViewToPopover(response) {
    let popover = "";
    let TO = this._global.getVal(response, 'to', '').split(',');
    popover += "<table>";
    popover += "<tr>";
    popover += "<td class='text-right' style='padding-right:10px;'>from:</td><td>" + this._global.getVal(response, 'from', '') + "</td>";
    popover += "</tr>";
    Object.entries(TO).forEach(([key, value]) => {
      popover += "<tr>";
      popover += "<td class='text-right' style='padding-right:10px;'> " + ((key == '0') ? "to:" : "") + "</td><td>" + value + "</td>";
      popover += "</tr>";
    });

    popover += "<tr>";
    popover += "<td class='text-right' style='padding-right:10px;'>date:</td><td>" + this.datePipe.transform(this._global.getVal(response, 'createdTime', ''), "EEE, MMM EE yy at hh:mm a") + "</td>";
    popover += "</tr><tr>";
    popover += "<td class='text-right' style='padding-right:10px;'>subject:</td><td>" + this._global.getVal(response, 'subject', 'no subject') + "</td>";
    popover += "</tr>";
    popover += "</table>";
    return popover;
  }

  showMail(label) {
    /* this.mailListForm = this.fb.group({
      list: new FormArray([])
    }); */
    this.visible('mail')
    let p = {
      'component': this.component,
      'application': this.application,
      'label': label,
      "start": 0,
      "rows": this.rows
    };
    this._mail.label(p).subscribe(
      data => {
        this.total_record = this._global.getVal(data, 'response.numFound', 0);
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.params = this._global.getVal(data, 'request', '');
          this.items = this._global.getVal(data, 'response.docs', '');
          /*  Object.entries(this.items).forEach(([key, value]) => {
             const control = this.fb.control('');
             (this.mailListForm.controls.list as FormArray).push(control);
           }); */
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  visible(template) {
    Object.entries(this.show).forEach(([key, value]) => {
      if (template == key) {
        this.show[key] = true;
      } else {
        this.show[key] = false;
      }
    });
  }
  compose() {
    this.pathToMedia = {};
    this.attachment_paths = [];
    this.upload_btn = false;
    this.visible('compose');
    this.btn_process = false;
    this.mailComposeForm.reset();
    this.to = [];
    this.cc = [];
    this.bcc = [];
    let p = {
      'component': this.component,
      'application': this.application
    };
    this._mail.compose(p).subscribe(
      data => {

        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.compose_response = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  public mailEmpty() {
    let p = {};
    p['component'] = this.component;
    p['application'] = this.application;
    this._mail.empty(p).subscribe(
      data => {
        if (data["status"] == 1) {
          this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
          this.loadMail();
        }
        else {
          this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
  public mailRestore() {
    let id = [];
    Object.entries(this.mailListForm.value['list']).forEach(([key, value]) => {
      if (value) {
        id.push(this.items[key]['id']);
      }
    });
    let p = {};
    p['component'] = this.component;
    p['application'] = this.application;
    p['id'] = id.join(",");
    if (_.isEmpty(p['id'])) {
      this._global.showMessage({ type: 'danger', message: 'Choose the mail' });
    } else {
      if (this.mlabel == 'trash') {
        this._mail.restore(p).subscribe(
          data => {
            if (data["status"] == 1) {
              this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
              this.loadMail();
            }
            else {
              this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
            }
          },
          error => {
            console.log("Validate Error", error);
          });
      } else {
        this._mail.remove(p).subscribe(
          data => {
            if (data["status"] == 1) {
              this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
              this.loadMail();
            }
            else {
              this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
            }
          },
          error => {
            console.log("Validate Error", error);
          });
      }
    }
  }
  public mailDelete() {
    let id = [];
    Object.entries(this.mailListForm.value['list']).forEach(([key, value]) => {
      if (value) {
        id.push(this.items[key]['id']);
      }
    });
    let p = {};
    p['component'] = this.component;
    p['application'] = this.application;
    p['id'] = id.join(",");
    if (_.isEmpty(p['id'])) {
      this._global.showMessage({ type: 'danger', message: 'Choose the mail' });
    } else {
      if (this.mlabel == 'trash') {
        this._mail.empty(p).subscribe(
          data => {
            if (data["status"] == 1) {
              this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
              this.loadMail();
            }
            else {
              this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
            }
          },
          error => {
            console.log("Validate Error", error);
          });
      } else {
        this._mail.remove(p).subscribe(
          data => {
            if (data["status"] == 1) {
              this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
              this.loadMail();
            }
            else {
              this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
            }
          },
          error => {
            console.log("Validate Error", error);
          });
      }
    }
  }
  public send() {
    this.error = { subject: '', body: '', bcc: '', cc: '', to: '' };
    this.btn_process = true;
    let to_value = [];
    let cc_value = [];
    let bcc_value = [];
    let p = this._global.generateParams(this.mailComposeForm.value, ['to', 'cc', 'bcc']);
    p['component'] = this.component;
    p['application'] = this.application;
    p['id'] = this._global.getVal(this.compose_response, 'id', '');
    if ((this.to).length > 0) {
      Object.entries(this.to).forEach(([key, value]) => {
        to_value.push(value['email']);

      });
    }
    if ((this.cc).length > 0) {
      Object.entries(this.cc).forEach(([key, value]) => {
        cc_value.push(value['email']);

      });
    }
    if ((this.bcc).length > 0) {
      Object.entries(this.bcc).forEach(([key, value]) => {
        bcc_value.push(value['email']);

      });
    }
    p['to'] = to_value.join(",");
    p['cc'] = cc_value.join(",");
    p['bcc'] = bcc_value.join(",");
    p = this._global.paramsRemoveNull(p);
    p['attachments'] = JSON.stringify(this.pathToMedia);
    this._mail.send(p).subscribe(
      data => {
        if (data["status"] == 1) {
          this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
          this.loadMail();
          this.mailComposeForm.reset();
          this.to = [];
          this.cc = [];
          this.bcc = [];
        }
        else {
          this.btn_process = false;
          for (let key in data["errors"]) {
            this.error[key] = data["errors"][key]["message"];
          }
          this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
  discard() {
    let p = {};
    p['component'] = this.component;
    p['application'] = this.application;
    p['id'] = this._global.getVal(this.compose_response, 'folder', '');
    this._mail.remove(p).subscribe(
      data => {
        if (data["status"] == 1) {
          this.loadMail();
          this.mailComposeForm.reset();
          this.to = [];
          this.cc = [];
          this.bcc = [];
        }
        else {
          for (let key in data["errors"]) {
            this.error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
  public draft() {
    this.error = { subject: '', body: '', bcc: '', cc: '', to: '' };
    this.btn_process = true;
    let to_value = [];
    let cc_value = [];
    let bcc_value = [];
    let p = this._global.generateParams(this.mailComposeForm.value, ['to', 'cc', 'bcc']);
    p['component'] = this.component;
    p['application'] = this.application;
    p['attachments'] = JSON.stringify(this.pathToMedia);
    p['id'] = this._global.getVal(this.compose_response, 'id', '');
    if ((this.to).length > 0) {
      Object.entries(this.to).forEach(([key, value]) => {
        to_value.push(value['email']);

      });
    }
    if ((this.cc).length > 0) {
      Object.entries(this.cc).forEach(([key, value]) => {
        cc_value.push(value['email']);

      });
    }
    if ((this.bcc).length > 0) {
      Object.entries(this.bcc).forEach(([key, value]) => {
        bcc_value.push(value['email']);

      });
    }
    p['to'] = to_value.join(",");
    p['cc'] = cc_value.join(",");
    p['bcc'] = bcc_value.join(",");
    p = this._global.paramsRemoveNull(p);
    this._mail.draft(p).subscribe(
      data => {
        if (data["status"] == 1) {
          this.loadMail();
          this.mailComposeForm.reset();
          this.to = [];
          this.cc = [];
          this.bcc = [];
        }
        else {
          for (let key in data["errors"]) {
            this.error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
  mail(label) {
    this.pathToMedia = {};
    this.checkbox_all = 0;
    this.dataLoding = true;
    this.items = [];
    this.mlabel = label;
    this.mailListForm = this.fb.group({
      list: new FormArray([])
    });
    this.visible('mail')
    let p = {
      'component': this.component,
      'application': this.application,
      'label': label,
      "start": 0,
      "rows": this.rows
    };
    this._mail.search(p).subscribe(
      data => {
        this.dataLoding = false;
        this.total_record = this._global.getVal(data, 'response.numFound', 0);
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.params = this._global.getVal(data, 'request', '');
          this.items = this._global.getVal(data, 'response.docs', '');
          Object.entries(this.items).forEach(([key, value]) => {
            const control = this.fb.control('');
            (this.mailListForm.controls.list as FormArray).push(control);
          });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.total_record <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._mail.search(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.items = this.items.concat(data["response"]["docs"]);
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
              Object.entries(this.items).forEach(([key, value]) => {
                const control = this.fb.control('');
                (this.mailListForm.controls.list as FormArray).push(control);
              });
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
        //  console.log('scrolled down!!', ev);

      }
    }
  }
  returnZero() {
    return 0
  }
  starred(id) {
    let p = {
      'component': this.component,
      'application': this.application,
      id: id,
      moveTo: 'starred',
      label: 'inbox'
    };
    this._mail.move(p).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
          this.loadMail();
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          this._global.showMessage({ type: severity, message: message });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  important(id) {
    let p = {
      'component': this.component,
      'application': this.application,
      id: id,
      moveTo: 'important',
      label: 'inbox'
    };
    this._mail.move(p).subscribe(
      data => {
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
          this.loadMail();
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          this._global.showMessage({ type: severity, message: message });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  view(id) {

    if (this.mlabel == 'draft') {
      this.visible('draft');
      this.btn_process = false;
    } else {
      this.view_page = true;
      this.visible('view');
    }
    let p = {
      id: id,
      'component': this.component,
      'application': this.application,
    };
    this._mail.view(p).subscribe(
      data => {
        if (this._global.getVal(data, 'status', '') == 1) {
          this.view_response = this._global.getVal(data, 'response', '')
          let attachment = this._global.getVal(this.view_response, 'attachments', {});
          this.pathToMedia = attachment;
          this.attachment_paths.push(this.pathToMedia);
          this.attachment_paths.push();
          this.view_page = false;
          Object.values(attachment).forEach((key, value) => {
            this.mail_attachments.push(key);
          });
          if (this.mlabel == 'draft') {
            this.compose_response = { id: this.view_response['id'], folder: this.view_response['folderId'] };
            let to = this._global.getVal(this.view_response, 'to', '');
            if (to) {
              this.view_response['to'] = this._global.mailDraftEmail(to);
            }
            let cc = this._global.getVal(this.view_response, 'cc', '');
            if (cc) {
              this.view_response['cc'] = this._global.mailDraftEmail(cc);
            }
            let bcc = this._global.getVal(this.view_response, 'bcc', '');
            if (bcc) {
              this.view_response['bcc'] = this._global.mailDraftEmail(bcc);
            }

          }
        } else {

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  memberSearch(event) {
    // this.members_response=[{email:'aa',id:'1'},{email:'bb',id:2}];
    let p = {
      'component': this.component,
      'application': 'member',
      firstName: event,
      lastName: event,
      start: 0,
      rows: 10
    };
    this._searchService.application(p).subscribe(
      data => {
        this.members_response = [];
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          let result = this._global.getVal(data, 'response.docs', '');
          for (let s in result) {
            this.members_response.push({ email: result[s]["email"], id: result[s]["id"] });
          }

        }
        return this.members_response;
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  remove(obj) {
    let p = {
      id: obj.folderId,
      label: obj.label,
      'component': this.component,
      'application': this.application,
    };
    this._mail.remove(p).subscribe(
      data => {
        if (data["status"] == 1) {
          this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
          this.loadMail();
        }
        else {
          this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  checkboxClick(event) {
    console.log("change", event)
    if (event == true) {
      this.checkBoxOption('all');
    } else {
      this.checkBoxOption('none');
    }
  }
  checkBoxOption(type) {
    this.checkbox_all = 0;
    if (type == 'all') {
      this.checkbox_all = 1;
      Object.entries(this.items).forEach(([key, value]) => {
        this.mailListForm.get('list').get(key).setValue(value['id']);
      });
    } else {
      Object.entries(this.items).forEach(([key, value]) => {
        this.mailListForm.get('list').get(key).setValue('');
      });
    }
  }
  isFoler(folder) {
    let r = false;
    let folders = ["inbox", "draft", "sent", "trash", "referral"];
    if (folders.indexOf(folder) == -1) {
      r = true;
    }
    return r;
  }
  createNewLabel() {
    this.mailLabelModal.show();
    //  this.ngxSmartModalService.getModal('mailLabel').open()
  }
  public onUploadVInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'attachment', '');
  }
  public onUploadVError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
    this.upload = false;
  }
  onUploadProcessing(args: any): void {
    this.upload = true;
  }
  onSending(args: any): void {
    //this.upload=true;
  }
  uploadBtn() {
    this.upload_btn = true;
  }
  public onUploadVSuccess(args: any): void {
    this.upload = false;
    let res = JSON.parse(args[1]);
    if (this._global.getVal(res, 'id', '')) {
      this.pathToMedia[res['id']] = this._global.getMailUploadPathToMedia(res);
      this.attachment_paths = [];
      this.attachment_paths.push(this.pathToMedia);
    }
  }
  removeImg(id) {
    if (this.attachment_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.attachment_paths = [];
      this.attachment_paths.push(this.pathToMedia);
    }
  }
  downloadFile(obj) {
    FileSaver.saveAs("//" + this._global.DOMAIN_NAME + "/cdn/attachment/" + obj['id'] + "/xl/" + obj['filename'], obj['filename']);
  }
  labelCreate() {
    let r = this.mailForm.value;
    r = this._global.paramsRemoveNull(r);
    let id = [];
    Object.entries(this.mailListForm.value['list']).forEach(([key, value]) => {
      if (value) {
        id.push(this.items[key]['id']);
      }
    });
    let p = {
      component: this.component,
      application: this.application,
      label: 'inbox',
      moveTo: r['label']

    };
    p['id'] = id.join(",");
    if (_.isEmpty(p['id'])) {
      this._global.showMessage({ type: 'danger', message: 'Choose the mail' });
    } else {

      this._mail.move(p).subscribe(
        data => {
          if (data["status"] == 1) {
            this._global.showMessage({ type: 'success', message: this._global.getVal(data, 'message.info', '') });
            this.loadMail();
          }
          else {
            this._global.showMessage({ type: 'danger', message: this._global.getVal(data, 'message.error', '') });
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }
  }
}